<template>
  <div>
    <PermissionValidation
      :marketId="marketId"
      rule="enableApproveSettingBilling"
    >
      <approve-list-setting
        :loading="isMainLoading"
        @onInit="getApproveTasksByMarket"
        subType="billing_setting"
        :approveTasks="approveTasks"
      ></approve-list-setting>
    </PermissionValidation>
  </div>
</template>

<script>
import ApproveListSetting from "../../components/ApproveListSetting.vue";
import PermissionValidation from "../../components/PermissionValidation.component.vue";
export default {
  components: {
    ApproveListSetting,
    PermissionValidation
  },
  props: {
    isMainLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    approveTasks() {
      return this.$store.getters["approveTask/getBySubType"]("billing_setting");
    }
  },
  data() {
    return {
      marketId: this.$route.params.marketId
    };
  },
  methods: {
    getApproveTasksByMarket() {
      this.$emit("onGetApproveTasksByMarket", "billing_setting");
    }
  }
};
</script>

<style>
</style>